import React from 'react';
import DestinationTemplate from '../../components/DestinationTemplate';

const RajasthanPage = () => {
  return <DestinationTemplate destinationId="rajasthan" />;
};

export default RajasthanPage;
